import React from 'react';
import { Icon } from '@iconify/react';

export default function PhotoGenerateSection({
  onGenerate,
  isGenerating,
  disabled,
  subtitle = '이미지 생성에 nanobanana 3.0을 사용합니다',
}) {
  return (
    <button className="photo-generate-btn" onClick={onGenerate} disabled={disabled}>
      <div className="photo-generate-btn-content">
        {isGenerating ? (
          <>
            <Icon icon="solar:magic-stick-3-bold" className="generate-icon" width={20} height={20} />
            생성 중...
          </>
        ) : (
          <>
            <Icon icon="solar:magic-stick-3-bold" width={20} height={20} />
            생성하기
          </>
        )}
        <span className="photo-generate-subtitle">{subtitle}</span>
      </div>
    </button>
  );
}


